export const AUTOCOMPLETE_ENDPOINT = '/api/wivi-inventory/autocomplete/';
export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 250];

export const DEFAULT_FILTERS = {
  vin: '',
  mac_id: '',
  remote_vehicle_id: '',
  remote_device_id: '',
  remote_fleet_name: '',
  remote_fleet_id: '',
  remote_organization_id: '',
  device_type: '',
  year: '',
  model: '',
  search: '',
};

export const FILTER_KEYS = Object.keys(DEFAULT_FILTERS);
